"use client";

import { useEffect, useState } from "react";
import type { CarouselApi } from "../../carousel";

const useSelectedIndex = (api: CarouselApi) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }
    const handleSelect = () => setSelectedIndex(api.selectedScrollSnap());
    handleSelect();
    api.on("select", handleSelect).on("reInit", handleSelect);
    return () => {
      api.off("select", handleSelect).off("reInit", handleSelect);
    };
  }, [api]);

  return selectedIndex;
};

export default useSelectedIndex;
